const getDefaultState = () => {
    return {
        token: '',
        mobile: '',
        addressId: '',
        code: '',
        name: '',
        username: '',
        id: '',
        expires_in: '', //token 过期时间
        expires_time: '' //token 过期时间
    };
};

const user = {
    state: getDefaultState(),
    mutations: {
        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
            localStorage.setItem('token', token);
        },
        SET_ENTER: (state, enter) => {
            state.enter = enter;
            localStorage.setItem('enter', JSON.stringify(enter));
        },
        SET_MOBILE: (state, mobile) => {
            state.mobile = mobile;
            localStorage.setItem('mobile', mobile);
        },
        SET_ADDRESSID: (state, addressId) => {
            state.addressId = addressId;
            localStorage.setItem('addressId', addressId);
        },
        SET_CODE: (state, code) => {
            state.code = code;
            localStorage.setItem('code', code);
        },
        SET_NAME: (state, name) => {
            state.name = name;
            localStorage.setItem('name', name);
        },
        SET_USERNAME: (state, username) => {
            state.username = username;
            localStorage.setItem('username', username);
        },
        SET_ID: (state, id) => {
            state.id = id;
            localStorage.setItem('id', id);
        },
        SET_EXPIRES_IN: (state, expires_in) => {
            state.expires_in = expires_in;
            localStorage.setItem('expires_in', expires_in);
        },
        SET_EXPIRES_TIME: (state, expires_time) => {
            state.expires_time = expires_time;
            localStorage.setItem('expires_time', expires_time);
        }
    },
    actions: {
        set_enter({ commit }, enter) {
            commit('SET_ENTER', enter);
            commit('SET_TOKEN', enter.token);
            commit('SET_MOBILE', enter.mobile);
            commit('SET_ADDRESSID', enter.addressId);
            commit('SET_CODE', enter.code);
            commit('SET_NAME', enter.name);
            commit('SET_USERNAME', enter.username);
            commit('SET_ID', enter.user_id);
            commit('SET_EXPIRES_IN', enter.expires_in);
            commit('SET_EXPIRES_TIME', enter.expires_time);
        },
        del_enter({ commit }) {
            commit('RESET_STATE');
            const temp = localStorage.getItem('userTableList');
            localStorage.clear();
            localStorage.setItem('userTableList', temp);
        },
        get_enter({ commit }) {
            let enter = localStorage.getItem('enter');
            if (enter) {
                commit('SET_ENTER', JSON.parse(enter));
                commit('SET_TOKEN', localStorage.getItem('token'));
                commit('SET_MOBILE', localStorage.getItem('mobile'));
                commit('SET_ADDRESSID', localStorage.getItem('addressId'));
                commit('SET_CODE', localStorage.getItem('code'));
                commit('SET_NAME', localStorage.getItem('name'));
                commit('SET_USERNAME', localStorage.getItem('username'));
                commit('SET_ID', localStorage.getItem('id'));
                commit('SET_EXPIRES_IN', localStorage.getItem('expires_in'));
                commit('SET_EXPIRES_TIME', localStorage.getItem('expires_time'));
            }
        }
    }
};

export default user;
